module.exports = __webpack_public_path__ + "img/qrcode_1.a6ffa989.jpg";